export const TASK_STATUS_IDS = ['not_started', 'in_progress', 'review', 'completed'];

export const TASK_STATUS_COLUMNS = [
  {
    id: 'not_started',
    label: 'To Do',
    shortLabel: 'To Do',
    color: '#3B82F6',
    bg: 'rgba(59,130,246,0.12)',
    border: 'rgba(59,130,246,0.35)',
  },
  {
    id: 'in_progress',
    label: 'In Progress',
    shortLabel: 'Doing',
    color: '#F59E0B',
    bg: 'rgba(245,158,11,0.12)',
    border: 'rgba(245,158,11,0.35)',
  },
  {
    id: 'review',
    label: 'Review',
    shortLabel: 'Review',
    color: '#A78BFA',
    bg: 'rgba(167,139,250,0.12)',
    border: 'rgba(167,139,250,0.35)',
  },
  {
    id: 'completed',
    label: 'Done',
    shortLabel: 'Done',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.12)',
    border: 'rgba(16,185,129,0.35)',
  },
];

export const TASK_STATUS_FILTER_OPTIONS = TASK_STATUS_COLUMNS.map((c) => ({
  value: c.id,
  label: c.label,
}));

export const TASK_STATUS_FORM_OPTIONS = TASK_STATUS_COLUMNS.map((c) => ({
  value: c.id,
  label: c.label,
}));

/** Effective status: DB field with fallback from legacy progress %. */
export function resolveTaskStatus(task) {
  const raw = task?.status;
  if (raw && TASK_STATUS_IDS.includes(raw)) {
    return raw;
  }
  const progress = Number.isFinite(Number(task?.progress)) ? Number(task.progress) : 0;
  if (progress >= 100) return 'completed';
  if (progress > 0) return 'in_progress';
  return 'not_started';
}

export function getTaskStatusMeta(statusId) {
  return TASK_STATUS_COLUMNS.find((c) => c.id === statusId) ?? TASK_STATUS_COLUMNS[0];
}

/** Map Kanban / form status to a representative progress %. */
export function progressForStatus(statusId) {
  switch (statusId) {
    case 'completed':
      return 100;
    case 'review':
      return 75;
    case 'in_progress':
      return 50;
    case 'not_started':
    default:
      return 0;
  }
}

export function taskMatchesStatusFilter(task, filterValue) {
  if (!filterValue) return true;
  return resolveTaskStatus(task) === filterValue;
}
